<template>
    <v-stepper-header style="position:sticky;top:0;background-color:white;z-index:1000;">
        <v-stepper-step
            editable
            :step="1"
            :rules="[ () => validations.step1 ]"
            @click="() => onClick_StepperHeader('1')">
            {{ editorMode !== 'combine' ? 'Flight Config' : 'Route Config' }}
        </v-stepper-step>

        <v-divider />

        <v-stepper-step
            :editable="validationSelectedFlights.step2IsEditable"
            step="2"
            :rules="[ () => validations.step2 ]"
            @click="() => onClick_StepperHeader('2')">
            Flight Dates<br>
            <span
                v-if="validationSelectedFlights.step2IsEditable === false"
                style="font-size: 0.8rem; margin-top: 4px; font-weight: 500;">
                only for same dates
            </span>
        </v-stepper-step>

        <v-divider />

        <v-stepper-step
            :editable="validationSelectedFlights.step3IsEditable"
            step="3"
            :rules="[ () => validations.step3 ]"
            @click="() => onClick_StepperHeader('3')">
            {{ editorMode !== 'combine' ? 'Route Config' : 'Flight Config' }}
            <span
                v-if="validationSelectedFlights.step3IsEditable === false"
                style="font-size: 0.8rem; margin-top: 4px; font-weight: 500;">
                only for single flights
            </span>
        </v-stepper-step>

        <v-divider v-if="editorMode === 'combine'" />

        <v-stepper-step
            v-if="editorMode === 'combine'"
            editable
            step="4"
            @click="() => onClick_StepperHeader('4')">
            Swap Flights
        </v-stepper-step>
    </v-stepper-header>
</template>

<script>

    export default {
        name: 'StepperHeader',


        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String, // 'update', 'create', 'extend'
            validations: Object, // Info about a specific step: is valid or not
            validationSelectedFlights: Object

        }, // eo props{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Methods */
        methods: {

            /*******************************************************************
            * Listeners
            *******************************************************************/
            /*******************************************************************
            * onClick_StepperHeader()
            *
            * Desc:
            * Note:
            *
            */
            onClick_StepperHeader: function(stepperNumber) {

                const me = this;


				me.$toc('>>> views/flights/flights/components/core/BottomSheet/StepperHeader.vue >>> onClick_StepperHeader');
                me.$emit('change', stepperNumber);

            } // eo function onClick_StepperHeader()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>

    .sdr-custom-tab-active {
        color: #AB3B7A !important;
    }

    .sdr-custom-tabs .v-item-group {
        padding-left: 0;
    }

</style>
